export default {
  API_URL:
    process.env.NODE_ENV === 'production'
      ? process.env.VUE_APP_API_URL
      : process.env.VUE_APP_API_DEV_URL,
};
